import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import dateFormat from 'dateformat';

import Footer from '../../../Components/Footer/Footer';
import Auth from '../../Authentication/Auth';
import Api from '../../../Services/Api';
import OilOrderGroupDetails from '../MonthlyOil/OilOrderGroupDetails';

class MonthlyOilPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      queryDate: new Date().getTime(),
      otherPlaneOrders: undefined,
      flightSchoolPlaneOrders: undefined,
      otherPlaneOrdersTotal: 0,
      flightSchoolPlaneOrdersTotal: 0,
      overallTotal: 0,
    };

    this.prevDateButtonClicked = this.prevDateButtonClicked.bind(this);
    this.nextDateButtonClicked = this.nextDateButtonClicked.bind(this);
    this.calculateTotal = this.calculateTotal.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  fetchData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.props.fboId}/reports/monthlyOil?timestamp=${this.state.queryDate}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const otherPlaneOrders = response.report.otherPlaneOrders;
      const flightSchoolPlaneOrders = response.report.flightSchoolPlaneOrders;

      this.setState({ otherPlaneOrders, flightSchoolPlaneOrders });

      const otherTotal = this.calculateTotal(otherPlaneOrders);
      const flightSchoolTotal = this.calculateTotal(flightSchoolPlaneOrders);

      this.setState({
        overallTotal: otherTotal + flightSchoolTotal,
        otherPlaneOrdersTotal: otherTotal,
        flightSchoolPlaneOrdersTotal: flightSchoolTotal,
      });
    }).catch((err) => {
      console.log(err);
    });
  }

  ordersExist(orders) {
    let exist = false;
    Object.keys(orders).forEach((key) => {
      if (orders[key].length > 0) {
        exist = true;
      }
    });

    return exist;
  }

  calculateTotal(orders) {
    let total = 0;
    orders.forEach((order) => {
      const oilOrder = order.oilOrder;
      if (oilOrder) {
        total += oilOrder.quantity;
      }
    });

    return total;
  }

  handlePrint() {
    window.print();
  }

  prevDateButtonClicked() {
    const date = new Date(this.state.queryDate);
    this.setState({ queryDate: new Date(date.getFullYear(), date.getMonth(), -1).getTime() }, () => {
      this.fetchData();
    });
  }

  nextDateButtonClicked() {
    const date = new Date(this.state.queryDate);
    this.setState({ queryDate: new Date(date.getFullYear(), date.getMonth() + 1, 1).getTime() }, () => {
      this.fetchData();
    });
  }

  renderTotal(title, total) {
    const formattedTotal = Number.parseFloat(total).toFixed(1);
    return (
      <article className="order-item">
        <span className="right">
          <strong>{title}: {formattedTotal} Gal</strong>
        </span>
      </article>
    );
  }

  renderOrderGroup(orders) {
    if (orders.length > 0) {
      return (<OilOrderGroupDetails
        orders={orders}
      />);
    }
    return null;
  }

  renderOtherOrders() {
    if (this.state.otherPlaneOrders) {
      return this.renderOrderGroup(this.state.otherPlaneOrders);
    }
    return (<article className="no-order-item">No completed fuel orders</article>);
  }

  renderFlightSchoolOrders() {
    if (this.state.flightSchoolPlaneOrders) {
      return this.renderOrderGroup(this.state.flightSchoolPlaneOrders);
    }
    return (<article className="no-order-item">No completed fuel orders</article>);
  }

  render() {
    const dateFormatOptions = { year: 'numeric', month: 'long' };

    return (
      <div className="app">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <main className="page-content">
        {/* GET THE FBO IMAGE */}
          <div className="reports-logo"><img src="https://pictures.dealer.com/t/tomwoodaviation/1142/45644ba64046387201eb9fdee519ecec.jpg" /></div>
          <div className="orders-page-header">
            <h1>Monthly Oil Report</h1>
            <div className="date-navigation">
              <button className="prev" onClick={this.prevDateButtonClicked}> &#60; </button>
              <button className="next" onClick={this.nextDateButtonClicked}> &#62; </button>
            </div>
            <h3>{new Date(this.state.queryDate).toLocaleDateString('en-US', dateFormatOptions)}</h3>

            <button
              className="btn btn-medium btn-primary right btn-print"
              onClick={this.handlePrint}
            >
              Print
            </button>
          </div>
          <section className="order-group">
            {this.renderOtherOrders()}
            {this.renderTotal('Total', this.state.otherPlaneOrdersTotal)}
            <h2>Flight School Planes:</h2>
            {this.renderFlightSchoolOrders()}
            {this.renderTotal('Total For: Flight School', this.state.flightSchoolPlaneOrdersTotal)}
            {this.renderTotal('Grand Total', this.state.overallTotal)}
          </section>
          <Footer />
        </main>
      </div>
    );
  }
}

MonthlyOilPage.propTypes = {
  fboId: PropTypes.number.isRequired,
};

export default MonthlyOilPage;




// WEBPACK FOOTER //
// ./src/Containers/Reports/MonthlyOil/MonthlyOilPage.js